import { render } from "./HelpVideoList.vue?vue&type=template&id=2e1f6c46&scoped=true"
import script from "./HelpVideoList.vue?vue&type=script&lang=js"
export * from "./HelpVideoList.vue?vue&type=script&lang=js"

import "./HelpVideoList.vue?vue&type=style&index=0&id=2e1f6c46&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2e1f6c46"

export default script

/* vue-cli-plugin-import-components */
import BaseIcon from "@/components/BaseIcon.vue";
import BaseButton from "@/components/BaseButton.vue";
import HelpVideoListItem from "@/components/HelpVideoListItem.vue";
script.components = Object.assign({}, { BaseIcon, BaseButton, HelpVideoListItem }, script.components);